import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hours" }
const _hoisted_2 = { class: "items" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerHours, (hour, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["hour", hour.type]),
          onClick: _withModifiers(($event: any) => (_ctx.changeHour(hour)), ["stop"])
        }, [
          _createElementVNode("div", null, _toDisplayString(hour.name), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}